import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL =
  import.meta.env.VITE_PUBLIC_SUPABASE_URL ||
  import.meta.env.VITE_SUPABASE_URL ||
  "";

const SUPABASE_ANON_KEY =
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error("Missing Supabase ENV variables");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: false,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
export const ip_supabase = supabase;

// Helper: limpiar tokens del localStorage y sessionStorage
function clearAllAuthStorage() {
  try {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('sb-') && key.includes('-auth-token')) {
        localStorage.removeItem(key);
      }
    });
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith('sb-') && key.includes('-auth-token')) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (_) {
    // ignore storage errors
  }
}

// Silenciar cualquier error de refresh token no manejado
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (e) => {
    const reason = e?.reason;
    const msg: string = (
      reason?.message ??
      reason?.error?.message ??
      reason?.msg ??
      String(reason ?? '')
    ).toLowerCase();
    if (msg.includes('refresh token') || msg.includes('invalid refresh')) {
      e.preventDefault();
      clearAllAuthStorage();
    }
  });
}

// Al iniciar, si hay sesión inválida, limpiar
supabase.auth.getSession().then(({ error }) => {
  if (error) {
    const msg = error.message?.toLowerCase() ?? '';
    if (msg.includes('refresh token') || msg.includes('invalid')) {
      clearAllAuthStorage();
    }
  }
});